import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChalkboardTeacher, ChatCircleDots, BookOpen } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function BureauEnseignants() {
  const [teachers, setTeachers] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/directory/teachers").then((r) => setTeachers(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="teachers-office-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">Campus virtuel</p>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Bureau des enseignants</h1>
        <p className="text-sm text-muted-foreground">Retrouvez le corps professoral et contactez-le directement.</p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {teachers.map((t) => (
          <div key={t.id} className="rounded-xl border border-border bg-card p-6" data-testid={`teacher-${t.id}`}>
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary text-lg font-bold text-primary-foreground">{t.name.split(" ").map((s) => s[0]).slice(0, 2).join("")}</div>
              <div>
                <h3 className="font-display text-lg font-bold leading-tight">{t.name}</h3>
                <p className="text-xs text-muted-foreground">{t.email}</p>
              </div>
            </div>
            <div className="mt-3 flex flex-wrap gap-1">
              {t.filiere && <Badge variant="secondary">{t.filiere}</Badge>}
              <Badge variant="secondary"><BookOpen size={12} className="mr-1" /> {t.courses_count} cours</Badge>
            </div>
            <Button variant="outline" className="mt-4 w-full" onClick={() => navigate("/app/messagerie")} data-testid={`contact-teacher-${t.id}`}>
              <ChatCircleDots size={16} className="mr-2" /> Contacter
            </Button>
          </div>
        ))}
        {teachers.length === 0 && <p className="text-sm text-muted-foreground">Aucun enseignant enregistré.</p>}
      </div>
    </div>
  );
}
